module.exports = __webpack_public_path__ + "minus.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/minus.svg?color1=%23333333&color2=
// module id = 2205
// module chunks = 67